import {
  type IGlobalTab,
  PresentationTypeConst,
  TabGroupName,
} from '@carboncopyco/types/desktop';
import { isInfoPagePresentation } from '../../shared/globalTabUtil';
import { useTabManager } from '../services/TabManager';
import { usePresentationService } from '../services/presenter/PresentationService';
import { useSpeakerPanelContext, useUser } from '../store/context';
import { usePlaybookPresentations } from './usePlaybookPresentations';

interface Props {
  tab: IGlobalTab;
  setIsCreatePresentationLoading: (val: boolean) => void;
  setShowCreatePresentation: (val: boolean) => void;
}

const useStartDemo = ({
  tab,
  setIsCreatePresentationLoading,
  setShowCreatePresentation,
}: Props) => {
  const tabToCheck = tab;
  const { activeOrganization } = useUser();
  const { handlePlayPlaybook } = usePlaybookPresentations({
    organizationId: `${activeOrganization?.id}`,
  });
  const { getActiveGlobalTab, closeGroupTabs } = useTabManager();
  const { setIsSpeakerPanelOpen } = useSpeakerPanelContext();
  const { openDemoPresentation } = usePresentationService();
  const { demo, presentation } = tabToCheck.payload;

  const onStartDemo = async () => {
    if (tabToCheck?.group?.name === TabGroupName.PlaybookPreview) {
      if (tabToCheck.payload?.play.asset) {
        handlePlayPlaybook({
          playSubset: tabToCheck.payload.play,
          shouldClosePreviewTab: true,
        });
        return;
      }
    }

    setIsSpeakerPanelOpen(false);

    await window.dsDesktop.speakerPanel.closeFromSpeakerPanelIfOpen({
      resetData: true,
    });

    if (isInfoPagePresentation(tabToCheck)) {
      try {
        setIsCreatePresentationLoading(true);
        const activeGlobalTab = getActiveGlobalTab();
        await closeGroupTabs(activeGlobalTab);
        const analyticsSessionId = window.dsDesktop.analyticsClient.start({
          presentationId: String(presentation.id),
          presentationType: PresentationTypeConst.demo,
          resourceType: 'managed_presentation',
          forClient: presentation.forClient,
        });
        await openDemoPresentation(presentation, demo, analyticsSessionId);
      } finally {
        setIsCreatePresentationLoading(false);
      }
    } else {
      setShowCreatePresentation(true);
    }
  };

  return {
    onStartDemo,
  };
};

export default useStartDemo;
